import React from 'react';
import { Fragment } from 'react';
import Footer from '../../../components/footer';
import Head from '../../../components/head';
import Header from '../../../components/headerrh';
import Funcionarios from '../../../components/rh/funcionarios/importar';


function ImportFuncionariosScreen () {
    return (
        <Fragment>
            <Head titulo="Importação em massa de Funcionarios | Consórcio LVF" />
            <Header />
            <Funcionarios />
            <Footer />
        </Fragment>
    );
}

export default ImportFuncionariosScreen;